/** @internal */ function calculateMorphBoundingBox(morphBoundingBox, keyframeBoundingBox, weights, numTargets) {
    morphBoundingBox.minPoint.setXYZ(0, 0, 0);
    morphBoundingBox.maxPoint.setXYZ(0, 0, 0);
    for(let i = 0; i < numTargets; i++){
        const weight = weights[i];
        const keyframeBox = keyframeBoundingBox[i];
        morphBoundingBox.minPoint.x += keyframeBox.minPoint.x * weight;
        morphBoundingBox.minPoint.y += keyframeBox.minPoint.y * weight;
        morphBoundingBox.minPoint.z += keyframeBox.minPoint.z * weight;
        morphBoundingBox.maxPoint.x += keyframeBox.maxPoint.x * weight;
        morphBoundingBox.maxPoint.y += keyframeBox.maxPoint.y * weight;
        morphBoundingBox.maxPoint.z += keyframeBox.maxPoint.z * weight;
    }
}

export { calculateMorphBoundingBox };
//# sourceMappingURL=morphtarget.js.map
